import React from 'react'
import ProfilePicture from '../assets/profile.jpg'
import OverviewPicture from '../assets/overview.png'

const OverviewView = () => {

    return (
        <section id='overview' className="text-gray-700 body-font">
            <div className="container px-5 pt-16 pb-5 mx-auto flex flex-col">
                <div className="lg:w-4/6 mx-auto">
                    <div className="rounded-lg h-64 overflow-hidden">
                        <img alt="content" className="object-cover object-center h-full w-full" src={OverviewPicture} />
                    </div>
                    <div className="flex flex-col sm:flex-row mt-10">
                        <div className="sm:w-1/3 text-center sm:pr-8 sm:py-8">
                            <div
                                className="w-20 h-20 rounded-full inline-flex items-center justify-center bg-gray-200 text-gray-400">
                               <img alt='Carlos Montes' src={ProfilePicture} className='rounded-full'/>
                            </div>
                            <div className="flex flex-col items-center text-center justify-center">
                                <h2 className="font-medium title-font mt-4 text-gray-900 text-lg">Carlos Montes "Kaito"</h2>
                                <div className="w-32 h-1 bg-purple-500 rounded mt-2 mb-4"/>
                                <p className="text-base text-gray-600">
                                    Software Engineer - Teacher - Piano Player - Cooking lover
                                </p>
                            </div>
                        </div>
                        <div className="sm:w-2/3 sm:pl-8 sm:py-8 sm:border-l border-gray-300 sm:border-t-0 border-t mt-4 pt-4 sm:mt-0 text-center sm:text-left">
                            <h2 className="text-2xl font-bold text-center">Overview</h2><br/>
                            <p className="leading-relaxed text-lg mb-4 text-justify">
                                I'm a Software Engineer with 7 years of experience, I started working as a backend developer,
                                across the years I learned to many languages an areas, such as Frontend and DevOps, also I'm trying
                                to become a Game Developer right know, but only as a hobie.
                                <br /><br />
                                A little more for myself, I really enjoy playing videogames, but is not the only thing that I do,
                                I like to create recipes in the kitchen and playing the piano.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default OverviewView